export default __webpack_public_path__ + "static/media/banner.d5c97e56.png";